module.exports = __webpack_public_path__ + "media/flip.2dd4d944.wav";